import {formatTimestamp, parseContent} from '@dv5/components'
import {DocumentPart} from '@dv5/domain'
import {FC} from 'react'
import './DiaryViewer.less'

interface Props {
    part: DocumentPart
    onChange: (partId: string, newContent: string) => void
}

export const DiaryViewer: FC<Props> = ({part}) => {
    const {items, todos} = parseContent(part.partContent)

    if (items.length === 0 && todos.length === 0) {
        return <div className="diary-viewer-empty">No diary entries</div>
    }

    return (
        <div className="diary-viewer">
            <div className="diary-viewer__columns">
                <div className="diary-viewer__column diary-viewer__column--items">
                    <div className="diary-viewer__column-title">Diary</div>
                    {items.length === 0 ? (
                        <div className="diary-viewer-empty">No diary entries</div>
                    ) : (
                        items.map((item) => {
                            const endTime = item.startTime + item.duration
                            return (
                                <div key={item.id} className="diary-viewer__item">
                                    <div className="diary-viewer__time">
                                        {formatTimestamp(item.startTime)} - {formatTimestamp(endTime)}
                                    </div>
                                    <div className="diary-viewer__text">{item.text}</div>
                                </div>
                            )
                        })
                    )}
                </div>
                <div className="diary-viewer__column diary-viewer__column--todos">
                    <div className="diary-viewer__column-title">Todos</div>
                    {todos.length === 0 ? (
                        <div className="diary-viewer-empty">No todos</div>
                    ) : (
                        todos.map((todo) => (
                            <div key={todo.id} className="diary-viewer__todo-item">
                                <span className="diary-viewer__todo-checkbox">
                                    {todo.checked ? '☑' : '☐'}
                                </span>
                                <span className={`diary-viewer__todo-title${todo.checked ? ' diary-viewer__todo-title--done' : ''}`}>
                                    {todo.title}
                                </span>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    )
}
